// Port of api/fuel/app/classes/insights/plays/year.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'year',
    default_: false,
    insight: ['year'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var year = vars.year || false
        var year_type = filter.year || 'version'
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''
        var games = []

        var collectionIndex = Util.queryFast(
            'SELECT g.game_id AS g,' +
            ' g.game_published AS gy,' +
            ' SUM(p.play_count) AS pc' +
            ' FROM play p' +
            ' JOIN game g ON p.game_id = g.game_id' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date <= ' + (range.end - 1) +
            ' AND g.game_type = 1' +
            sqlCount +
            ' GROUP BY g.game_published, g.game_id' +
            ' ORDER BY SUM(p.play_count) DESC, g.game_sortname ASC'
        )

        for (var i = 0; i < collectionIndex.length; i++) {
            var item = collectionIndex[i]

            var collectionYear = item.gy ? parseInt(item.gy, 10) : 0

            if (collectionYear === year) {
                this._references.games.push(item.g)

                games.push({
                    id: parseInt(item.g, 10),
                    subtext: '',
                    plays: parseInt(item.pc, 10)
                })
            }
        }

        return {
            year: year,
            games: games
        }

    }
})
